import type { DocViewSchema } from "./types";

/**
 * DocViewSchema for Item Customization Template.
 *
 * Single scrollable view (no tabs) with 4 widget sections:
 * - Template Info: name, description, status badge (this epic)
 * - Fields: DnD field builder (Epic 02)
 * - Rules: collapsible conditional rules (Epic 03)
 * - Linked Products: read-only product list (Epic 03)
 */
export const itemCustomizationTemplateDocViewSchema: DocViewSchema = {
  doctype: "Item Customization Template",
  views: {
    experience: {
      style: "shopify",
      sections: [
        {
          id: "template-info",
          label: "Template Info",
          widgetId: "TemplateInfoWidget",
        },
        {
          id: "template-fields",
          label: "Fields",
          widgetId: "TemplateFieldBuilderWidget",
        },
        {
          id: "template-rules",
          label: "Rules",
          widgetId: "TemplateRulesWidget",
        },
        {
          id: "template-linked-products",
          label: "Linked Products",
          widgetId: "TemplateLinkedProductsWidget",
        },
      ],
      // No tabs — single scrollable view (Decision 1 from user story)
    },
  },
};
